import space from '../namespace';
import { IState } from '../state';
import actionTypes, { IAction, ActionTypeValues } from '../actionTypes';

const reducer = (
  state: IState,
  action: IAction<
    Partial<IState[space.device]> & {
      namespace?: `${space}`;
      resetKeys?: string[];
    }
  > & { slug: string },
): IState => {
  const { type, namespace = space.device, payload, slug } = action;

  switch (type) {
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICE_CHANNEL_LIST]: {
      const _state = state[namespace as space.device];
      const _deviceState = _state[slug] || {};
      return {
        ...state,
        [namespace]: {
          ..._state,
          [slug]: {
            ..._deviceState,
            channelList: payload
          }
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICE_ARTICAL_LIST]: {
      const _state = state[namespace as space.device];
      const _deviceState = _state[slug] || {};
      return {
        ...state,
        [namespace]: {
          ..._state,
          [slug]: {
            ..._deviceState,
            articalList: { ...(_deviceState?.articalList || {}), ...payload }
          }
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICE_CHANNEL_ACTIVE_KEYS]: {
      const _state = state[namespace as space.device];
      const _deviceState = _state[slug] || {};
      return {
        ...state,
        [namespace]: {
          ..._state,
          [slug]: {
            ..._deviceState,
            channelActiveKeys: payload,
          }
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICE_CHANNEL_SORT_KEY_MAP]: {
      const _state = state[namespace as space.device];
      const _deviceState = _state[slug] || {};
      return {
        ...state,
        [namespace]: {
          ..._state,
          [slug]: {
            ..._deviceState,
            channelSortKeyMap: { ...(_deviceState?.channelSortKeyMap || {}), ...payload },
          },
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICE_NAME]: {
      const _state = state[namespace as space.device];
      const _deviceState = _state[slug] || {};
      return {
        ...state,
        [namespace]: {
          ..._state,
          [slug]: {
            ..._deviceState,
            deviceName: payload,
          },
        }
      }
    }
    default:
      return state;
  }
};

export default reducer;
